import React from 'react';
import { InstitutionSettings } from '../components/landing';
import { useSessionState, useSessionActions } from '../context/SessionContext';
import { useShellUiActions } from '../context/ShellUiContext';

// BAR-40 S3: /settings route. Replaces the settings ternary branch (verbatim).
export default function SettingsRoute() {
  const { regulatorySettings } = useSessionState();
  const { handleSettingsChange } = useSessionActions();
  const { navigateToView } = useShellUiActions();
  return (
    // BAR-1294: `flex flex-col h-full` because there are two children now.
    // `InstitutionSettings` is itself `h-full`, so a bare sibling above it
    // overflowed the route box by the header's height and clipped the bottom
    // of the settings panel.
    <div className="flex flex-col h-full">
      <div className="border-b border-border-default px-6 py-3 flex items-center justify-between">
        <span className="text-sm text-fg-secondary">
          Subscription, payment method and invoices
        </span>
        <button
          type="button"
          onClick={() => navigateToView('billing')}
          className="inline-flex items-center gap-2 min-h-8 px-3 py-1.5 text-xs font-semibold text-fg-secondary hover:text-fg hover:bg-bg-warm rounded-md focus-visible:outline-none focus-visible:shadow-bark-focus transition-colors"
        >
          Manage billing
        </button>
      </div>
      <div className="flex-1 min-h-0">
        <InstitutionSettings
          regulatorySettings={regulatorySettings}
          onSettingsChange={handleSettingsChange}
          onBack={() => navigateToView('landing')}
        />
      </div>
    </div>
  );
}
